var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-container"},[_c('img',{staticClass:"loading-image",attrs:{"src":"/static/unstruct-logo-new.png","alt":"Loading..."}}),_c('div',{staticClass:"loading-ring"}),_c('div',{staticClass:"loading-pulse"})])])
}]

export { render, staticRenderFns }